import { create } from "zustand";

const useAppStore = create((set) => ({
  token: null,
  setToken: (token) => set({ token }),
  accessLevel: 0,
  setAccessLevel: (accessLevel) => set({ accessLevel }),
  loading: false,
  setLoading: (loading) => set({ loading }),
  isRTL: false,
  setIsRTL: (isRTL) => set({ isRTL }),
  language: 'en',
  setLanguage: (language) => set({ language }),
  maskedNumber: null,
  setMaskedNumber: (maskedNumber) => set({ maskedNumber }),
}));

export default useAppStore;
